import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'cp-history',
    templateUrl: 'cp-history.html',
    providers: []
})
export class CpHistory {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/cp-history/cp-history.ts